export default "__VITE_ASSET__CfxCxXnm__"